import { Form, Input } from "antd";
import {CardElement} from "@stripe/react-stripe-js";
import React, {useState} from "react";
import {StripeCardElementChangeEvent} from "@stripe/stripe-js";

interface BillingCardProps {
  firstName: string;
  lastName: string;
  onChangeClick: (type: string, value: string) => void;
  onCardChange: (complete: boolean) => void;
}

export default function BillingCard({
  firstName,
  lastName,
  onChangeClick,
  onCardChange
}: BillingCardProps) {
  const [error, setError] = useState('');

  function onChange(e: StripeCardElementChangeEvent) {
    onCardChange(e.complete);
    setError(e.error?.message || '');
  }

  return (
    <section className={"c-card"}>
      <div className={"blk row"}>
        <Form.Item
          name="first"
          rules={[{ required: true, message: "First Name required" }]}
        >
          <div className={"col"}>
            <label>First Name</label>
            <Input
              type={"text"}
              defaultValue={firstName}
              placeholder={"First Name"}
              onChange={(ev) => onChangeClick("firstName", ev.target.value)}
            />
          </div>
        </Form.Item>

        <Form.Item
          name="last"
          rules={[{ required: true, message: "Last Name required" }]}
        >
          <div className={"col"}>
            <label>Last Name</label>
            <Input
              type={"text"}
              defaultValue={lastName}
              placeholder={"Last Name"}
              onChange={(ev) => onChangeClick("lastName", ev.target.value)}
            />
          </div>
        </Form.Item>
      </div>

      <Form.Item>
        <label>Credit card data</label>
        <CardElement onChange={onChange}/>
        {error && <span className={'err'}>{error}</span>}
      </Form.Item>
    </section>
  );
}
